/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clientWorkspaceUserControllerCreateMember } from '../fn/client-workspace-user/client-workspace-user-controller-create-member';
import { ClientWorkspaceUserControllerCreateMember$Params } from '../fn/client-workspace-user/client-workspace-user-controller-create-member';
import { clientWorkspaceUserControllerDelegate } from '../fn/client-workspace-user/client-workspace-user-controller-delegate';
import { ClientWorkspaceUserControllerDelegate$Params } from '../fn/client-workspace-user/client-workspace-user-controller-delegate';
import { clientWorkspaceUserControllerDeportUser } from '../fn/client-workspace-user/client-workspace-user-controller-deport-user';
import { ClientWorkspaceUserControllerDeportUser$Params } from '../fn/client-workspace-user/client-workspace-user-controller-deport-user';
import { clientWorkspaceUserControllerFindUserById } from '../fn/client-workspace-user/client-workspace-user-controller-find-user-by-id';
import { ClientWorkspaceUserControllerFindUserById$Params } from '../fn/client-workspace-user/client-workspace-user-controller-find-user-by-id';
import { clientWorkspaceUserControllerFindUsersByWorkspaceId } from '../fn/client-workspace-user/client-workspace-user-controller-find-users-by-workspace-id';
import { ClientWorkspaceUserControllerFindUsersByWorkspaceId$Params } from '../fn/client-workspace-user/client-workspace-user-controller-find-users-by-workspace-id';
import { clientWorkspaceUserControllerSearchOffset } from '../fn/client-workspace-user/client-workspace-user-controller-search-offset';
import { ClientWorkspaceUserControllerSearchOffset$Params } from '../fn/client-workspace-user/client-workspace-user-controller-search-offset';
import { clientWorkspaceUserControllerUpdateUser } from '../fn/client-workspace-user/client-workspace-user-controller-update-user';
import { ClientWorkspaceUserControllerUpdateUser$Params } from '../fn/client-workspace-user/client-workspace-user-controller-update-user';
import { clientWorkspaceUserControllerWithdraw } from '../fn/client-workspace-user/client-workspace-user-controller-withdraw';
import { ClientWorkspaceUserControllerWithdraw$Params } from '../fn/client-workspace-user/client-workspace-user-controller-withdraw';
import { ClientWorkspaceUserDto } from '../models/client-workspace-user-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class ClientWorkspaceUserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientWorkspaceUserControllerFindUsersByWorkspaceId()` */
  static readonly ClientWorkspaceUserControllerFindUsersByWorkspaceIdPath = '/api/clientWorkspaceUser/{id}/users';

  /**
   * 고객사 ID 기반 구성원 목록 조회.
   *
   * 고객사 ID를 기반으로 구성원 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceUserControllerFindUsersByWorkspaceId()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerFindUsersByWorkspaceId$Response(params: ClientWorkspaceUserControllerFindUsersByWorkspaceId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientWorkspaceUserDto>>> {
    return clientWorkspaceUserControllerFindUsersByWorkspaceId(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 ID 기반 구성원 목록 조회.
   *
   * 고객사 ID를 기반으로 구성원 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceUserControllerFindUsersByWorkspaceId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerFindUsersByWorkspaceId(params: ClientWorkspaceUserControllerFindUsersByWorkspaceId$Params, context?: HttpContext): Observable<Array<ClientWorkspaceUserDto>> {
    return this.clientWorkspaceUserControllerFindUsersByWorkspaceId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientWorkspaceUserDto>>): Array<ClientWorkspaceUserDto> => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceUserControllerCreateMember()` */
  static readonly ClientWorkspaceUserControllerCreateMemberPath = '/api/clientWorkspaceUser/{id}/users';

  /**
   * 고객사 구성원 직접 생성.
   *
   * 관리자가 직접 정보를 입력하여 구성원 계정을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceUserControllerCreateMember()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceUserControllerCreateMember$Response(params: ClientWorkspaceUserControllerCreateMember$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
    return clientWorkspaceUserControllerCreateMember(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 구성원 직접 생성.
   *
   * 관리자가 직접 정보를 입력하여 구성원 계정을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceUserControllerCreateMember$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceUserControllerCreateMember(params: ClientWorkspaceUserControllerCreateMember$Params, context?: HttpContext): Observable<ClientWorkspaceUserDto> {
    return this.clientWorkspaceUserControllerCreateMember$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceUserDto>): ClientWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceUserControllerSearchOffset()` */
  static readonly ClientWorkspaceUserControllerSearchOffsetPath = '/api/clientWorkspaceUser/search/offset';

  /**
   * 고객사 구성원 오프셋 기반 검색.
   *
   * 고객사 구성원을 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceUserControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerSearchOffset$Response(params: ClientWorkspaceUserControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items'?: Array<ClientWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
}>> {
    return clientWorkspaceUserControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 구성원 오프셋 기반 검색.
   *
   * 고객사 구성원을 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceUserControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerSearchOffset(params: ClientWorkspaceUserControllerSearchOffset$Params, context?: HttpContext): Observable<{
'items'?: Array<ClientWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
}> {
    return this.clientWorkspaceUserControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'items'?: Array<ClientWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
}>): {
'items'?: Array<ClientWorkspaceUserDto>;
'pageInfo'?: PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceUserControllerFindUserById()` */
  static readonly ClientWorkspaceUserControllerFindUserByIdPath = '/api/clientWorkspaceUser/{id}/users/{userId}';

  /**
   * 고객사 구성원 ID 기반 조회.
   *
   * 고객사 구성원을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceUserControllerFindUserById()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerFindUserById$Response(params: ClientWorkspaceUserControllerFindUserById$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
    return clientWorkspaceUserControllerFindUserById(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 구성원 ID 기반 조회.
   *
   * 고객사 구성원을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceUserControllerFindUserById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerFindUserById(params: ClientWorkspaceUserControllerFindUserById$Params, context?: HttpContext): Observable<ClientWorkspaceUserDto> {
    return this.clientWorkspaceUserControllerFindUserById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceUserDto>): ClientWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceUserControllerUpdateUser()` */
  static readonly ClientWorkspaceUserControllerUpdateUserPath = '/api/clientWorkspaceUser/{id}/users/{userId}';

  /**
   * 고객사 구성원 역할 변경.
   *
   * 고객사 구성원의 역할을 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceUserControllerUpdateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceUserControllerUpdateUser$Response(params: ClientWorkspaceUserControllerUpdateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
    return clientWorkspaceUserControllerUpdateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 구성원 역할 변경.
   *
   * 고객사 구성원의 역할을 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceUserControllerUpdateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientWorkspaceUserControllerUpdateUser(params: ClientWorkspaceUserControllerUpdateUser$Params, context?: HttpContext): Observable<ClientWorkspaceUserDto> {
    return this.clientWorkspaceUserControllerUpdateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceUserDto>): ClientWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceUserControllerDelegate()` */
  static readonly ClientWorkspaceUserControllerDelegatePath = '/api/clientWorkspaceUser/{id}/users/{userId}/delegate';

  /**
   * 고객사 대표 위임.
   *
   * 고객사 대표를 위임합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceUserControllerDelegate()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerDelegate$Response(params: ClientWorkspaceUserControllerDelegate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
    return clientWorkspaceUserControllerDelegate(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 대표 위임.
   *
   * 고객사 대표를 위임합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceUserControllerDelegate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerDelegate(params: ClientWorkspaceUserControllerDelegate$Params, context?: HttpContext): Observable<ClientWorkspaceUserDto> {
    return this.clientWorkspaceUserControllerDelegate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceUserDto>): ClientWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceUserControllerWithdraw()` */
  static readonly ClientWorkspaceUserControllerWithdrawPath = '/api/clientWorkspaceUser/{id}/withdraw';

  /**
   * 고객사 탈퇴.
   *
   * 고객사에서 탈퇴합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceUserControllerWithdraw()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerWithdraw$Response(params: ClientWorkspaceUserControllerWithdraw$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
    return clientWorkspaceUserControllerWithdraw(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 탈퇴.
   *
   * 고객사에서 탈퇴합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceUserControllerWithdraw$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerWithdraw(params: ClientWorkspaceUserControllerWithdraw$Params, context?: HttpContext): Observable<ClientWorkspaceUserDto> {
    return this.clientWorkspaceUserControllerWithdraw$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceUserDto>): ClientWorkspaceUserDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceUserControllerDeportUser()` */
  static readonly ClientWorkspaceUserControllerDeportUserPath = '/api/clientWorkspaceUser/{id}/deport/{userId}';

  /**
   * 고객사 구성원 추방.
   *
   * 고객사 구성원을 추방합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceUserControllerDeportUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerDeportUser$Response(params: ClientWorkspaceUserControllerDeportUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceUserDto>> {
    return clientWorkspaceUserControllerDeportUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 구성원 추방.
   *
   * 고객사 구성원을 추방합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceUserControllerDeportUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceUserControllerDeportUser(params: ClientWorkspaceUserControllerDeportUser$Params, context?: HttpContext): Observable<ClientWorkspaceUserDto> {
    return this.clientWorkspaceUserControllerDeportUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientWorkspaceUserDto>): ClientWorkspaceUserDto => r.body)
    );
  }

}
